import Swiper, { Navigation } from 'swiper/core';
import * as fireworks from 'fireworks.js';

// S'assure qu'un hash contient bel et bien son symbole '#'.
export function normalizeHash( hash, withSymbol = true ) {
	let newHash = hash ? hash.replace( '#', '' ) : '';

	if( newHash && withSymbol ) {
		newHash = '#' + newHash;
	}

	return newHash;
}

export function showNextPage( theHash ) {
	// Get active page and hide it
	let nextPageID = theHash;

	// console.log(nextPageID);

	let activePage = document.querySelector('.app-page.page-active');
	let nextPage = document.getElementById( nextPageID );

	let transitionOut = {
		home: 'out:circle:center',
		mix: 'out:circle:top-right',
		form: 'out:circle:top-right',
		thanks: 'out:circle:top-right',
	}

	activePage.setAttribute('transition-style', transitionOut[activePage.getAttribute('id')]);

	setTimeout( function() {
		activePage.classList.add('hidden');
		activePage.classList.remove('page-active');

		window.scrollTo(0, 0);

		// nextPage.setAttribute('transition-style', 'in:wipe:down');
		nextPage.classList.remove('hidden');
		nextPage.classList.add('page-active');

		if( nextPage.getAttribute('id') == 'mix' ) {
			initFlavorSlider();

			/*setTimeout( function() {
				document.querySelectorAll('.finger-scroll').forEach( function( thisEl ) {
					thisEl.style.display = 'none';
				} );
			}, 10000);*/
		} else if( nextPage.getAttribute('id') == 'thanks' ) {
			let windowWidth = window.innerWidth - 100,
				windowHeight = window.innerHeight - 100,
				randomX, randomY;

			randomX = Math.floor( Math.random() * windowWidth ) + 100;
			randomY = Math.floor( Math.random() * windowHeight ) + 100;

			fireworks.launchFirework( randomX, randomY, 1500 );

			randomX = Math.floor( Math.random() * windowWidth ) + 100;
			randomY = Math.floor( Math.random() * windowHeight ) + 100;

			fireworks.launchFirework( randomX, randomY, 2400 );

			randomX = Math.floor( Math.random() * windowWidth ) + 100;
			randomY = Math.floor( Math.random() * windowHeight ) + 100;

			fireworks.launchFirework( randomX, randomY, 3800 );

			randomX = Math.floor( Math.random() * windowWidth ) + 100;
			randomY = Math.floor( Math.random() * windowHeight ) + 100;

			fireworks.launchFirework( randomX, randomY, 4300 );

			randomX = Math.floor( Math.random() * windowWidth ) + 100;
			randomY = Math.floor( Math.random() * windowHeight ) + 100;

			fireworks.launchFirework( randomX, randomY, 5200 );
		}

		/*window.history.pushState(
			{
				id: 'page-' + nextPageID
			},
			'test',
			nextPageID
		);*/
	}, 1500 );
}

export function saveAs( uri, filename ) {
	var link = document.createElement('a');

	if( typeof link.download === 'string' ) {
		link.href = uri;
		link.download = filename;

		//Firefox requires the link to be in the body
		document.body.appendChild( link );

		//simulate click
		link.click();

		//remove the link when done
		document.body.removeChild( link );
	} else {
		window.open( uri );
	}
}

export function shareToFacebook( uri ) {
	let formData = new FormData(),
		xhr, imageDataRaw;

	imageDataRaw = uri.replace(/^data:image\/\w+;base64,/, "");

	formData.append( 'action', 'base64_to_jpeg' );
	formData.append( 'image', imageDataRaw );
	formData.append( 'image_type', 'jpg' );

	xhr = new XMLHttpRequest();

	xhr.onreadystatechange = function() {
		if( xhr.readyState == 4 ) {
			let response = JSON.parse( xhr.responseText );

			let image_full_url = encodeURIComponent( window.bonesGlobals.baseUrl + response.data.image_url );

			if( xhr.status == 200 ) {
				if( response.status === 'success' ) {
					window.open("https://www.facebook.com/sharer/sharer.php?u=" + image_full_url, "fbpop", "width=600, height=400, scrollbars=no");
				}
			} else {
				console.log( response );
			}
		}
	};

	xhr.open( "POST", bonesGlobals.ajaxUrl );
	xhr.send( formData );
}

// Convert a data URI to blob
function dataURItoBlob( dataURI, mime ) {
	let byteString = window.atob( dataURI );
	let ia = new Uint8Array( byteString.length );

	for( let i = 0; i < byteString.length; i++ ) {
		ia[i] = byteString.charCodeAt( i );
	}

	let blob = new Blob( [ ia ], { type: mime } );

	return blob;
}

/*** Sliders Swiper ****************************************************************************************/
// Requiert Swiper (import Swiper from 'swiper';)
export function initFlavorSlider() {
	let flavorsSlider = document.querySelectorAll('.page-mix .flavors-slider'),

		selectedFlavors = document.getElementById('image-generator-flavors'),

		fingerScroll = document.querySelectorAll('.finger-scroll'),

		mixGeneratorImages = {
			ice_cream: {
				pellet: selectedFlavors.querySelector('.ice-cream .pellet img'),
				cone: selectedFlavors.querySelector('.ice-cream .cone img'),
				title: document.getElementById('ice-cream-title'),
				color: selectedFlavors.querySelector('.ice-cream'),
				inputHidden: document.getElementById('ice-cream-flavor')
			},
			chocolate: {
				pellet: selectedFlavors.querySelector('.chocolate .pellet img'),
				cone: selectedFlavors.querySelector('.chocolate .cone img'),
				title: document.getElementById('chocolate-title'),
				color: selectedFlavors.querySelector('.chocolate'),
				inputHidden: document.getElementById('chocolate-flavor')
			}
		};

	Swiper.use( [ Navigation ] );

	flavorsSlider.forEach( function( sliderEl ) {
		if( scriptsOk( sliderEl ) ) {
			let whichSlider = sliderEl.dataset.whichSlider;

			let sliderOptions = {
				// wrapperClass: 'flavor-slides'
				direction: 'vertical',
				loop: true,
				preloadImages: false,
				lazy: {
					loadPrevNext: true,
				},
				navigation: {
					nextEl: '.next',
					prevEl: '.prev',
				}
			};

			let sliderInstance = new Swiper( sliderEl, sliderOptions );

			sliderInstance.on( 'slideChange', function(){
				fingerScroll.forEach( function( thisEl ) {
					thisEl.style.display = 'none';
				} );

				// Aller chercher les données de la slide active
				let indexCurrentSlide = sliderInstance.activeIndex !== undefined ? sliderInstance.activeIndex : 0,
					activeSlide = sliderInstance.slides[ indexCurrentSlide ],

					pelletImg = activeSlide.querySelector('.pellet img').getAttribute('src'),
					coneImg = activeSlide.querySelector('.cone img').getAttribute('src'),

					flavorID = activeSlide.dataset.flavorId,
					flavorTitle = activeSlide.dataset.flavorTitle,
					flavorColor = activeSlide.dataset.flavorColor;

				// Affecter les données aux bons endroits du form
				mixGeneratorImages[whichSlider].pellet.setAttribute('src', pelletImg);
				mixGeneratorImages[whichSlider].cone.setAttribute('src', coneImg);
				mixGeneratorImages[whichSlider].title.textContent = flavorTitle;
				mixGeneratorImages[whichSlider].color.style.backgroundColor = flavorColor;
				// mixGeneratorImages[whichSlider].color.style.backgroundImage = 'url(' + coneImg + ')';

				mixGeneratorImages[whichSlider].inputHidden.setAttribute('value', flavorID);
			} );
		}
	} );
}


// Prend un d'ID #hash, et renvoie une node HTMLElement (ou alors renvoie ce qu'on a reçu si c'en est déjà un)

export function getElementByHash( selector ) {
	let element;

	if( selector ) {
		if( 'string' == typeof selector ) {
			element = document.querySelector( normalizeHash( selector ) );
		} else {
			element = selector;
		}
	} else {
		element = null;
	}

	return element;
}


// Change le hash de la page, mais ne scroll pas vers ce hash.
// historyAction: 'push' (ajoute à l'historique) | 'replace' (n'ajoute pas à l'historique mais remplace l'état actuel)
export function changeHashWithoutScrolling( hash = null, historyStateObj = null, historyAction = 'push' ) {
	hash = normalizeHash( hash );
	let curHash = normalizeHash( window.location.hash );

	if( hash != curHash ) {
		let urlForHistory = hash ? hash : window.location.href.replace( /#.*$/, '' );

		if( 'push' == historyAction ) {
			history.pushState( historyStateObj, null, urlForHistory );
		} else if( 'replace' == historyAction ) {
			history.replaceState( historyStateObj, null, urlForHistory );
		}
	}
}


// elem : Élément DOM sur lequel on se pose la question
// offset : Nombre de pixels de grâce (nombre plus gros = plus tolérant)
// completelyInside : si true, l'élément doit être à 100% dans le viewport ; si false, il peut dépasser
// parent : par rapport à quoi? | défaut window/viewport

export function isInViewport( elem, offset, completelyInside, parent ) {
	offset = offset || ( -1 * window.fixedElHeight );
	completelyInside = completelyInside || false;
	parent = parent || window;

	let condition;
	let viewportBottom;
	let viewportTop;
	let elemTop;
	let elemBottom;

	if( 'string' == typeof elem ) {
		elem = document.querySelector( elem );
	}

	if( elem ) {
		if( parent == window ) {
			viewportTop = 0;
			viewportBottom = window.vHeight;
			elemTop = elem.getBoundingClientRect().top;
			elemBottom = elem.getBoundingClientRect().bottom;
		} else {
			viewportTop = parent.scrollTop;
			viewportBottom = parent.scrollTop + parent.offsetHeight;
			elemTop = elem.offsetTop;
			elemBottom = elem.offsetBottom + elem.offsetHeight;
		}


		if( completelyInside ) {
			condition = (
				( elemTop >= viewportTop + offset && elemTop < viewportBottom - offset ) &&
				( elemBottom >= viewportTop + offset && elemBottom < viewportBottom - offset )
			);
		} else {
			condition = (
				( elemTop >= viewportTop + offset && elemTop < viewportBottom - offset ) ||
				( elemBottom >= viewportTop + offset && elemBottom < viewportBottom - offset )
			);
		}
	} else {
		condition = null;
	}

	return condition;
}


// Fait apparaître des trucs quand ils entrent dans le viewport

export function smoothFadeIn( thisEl ) {
	if( ! thisEl.classList.contains( 'visible' ) && isInViewport( thisEl ) ) {
		thisEl.classList.add( 'visible' );
	}
}


// Change complètement l'URL de la page sans rediriger en enregistrant le changement dans l'historique.
// objet d'args :
// context('open'/'close') : 'open' = ouverture du popup / 'close' = retour à l'URL d'origine.

export function changeUrl( args ) {
	let returnVal;

	switch(args.context) {
		case 'open':
			window.changeUrlOriginalTitle = document.title;
			window.changeUrlOriginalUrl = window.location.href;
			window.changeUrlOriginalId = document.body.dataset.id || window.location.href;

			window.history.pushState(
				{
					id: 'popup-' + args.id
				},
				args.title,
				args.url
			);
			document.title = args.title;

			returnVal = true;
			break;

		case 'close':
			if( window.changeUrlOriginalId ) {
				window.history.pushState(
					{
						id: window.changeUrlOriginalId
					},
					window.changeUrlOriginalTitle,
					window.changeUrlOriginalUrl
				);
				document.title = window.changeUrlOriginalTitle;

				window.changeUrlOriginalTitle = null;
				window.changeUrlOriginalUrl = null;
				window.changeUrlOriginalId = null;

				returnVal = true;
				break;
			}
	}

	return returnVal;
}


// S'assure qu'aucun caractère réservé n'est dans une string pour regex

export function escapeRegExp(text) {
	if ( ! text || 'string' != typeof text ) {
		return '';
	}
	return text.replace(/[-[\]{}()*+?.,\\/^$|#\s]/g, '\\$&');
}


// Est-ce que tous les éléments de cet array sont la même chose?

export function arrayAllEqual( array ) {
	return array.every( function( elementToCheck ) {
		return elementToCheck === array[0];
	} );
}


// Est-ce que toutes ces URLs sont la même chose?
// objet d'args :
// urls(array) : URLS à vérifier
// stripHash(bool) : retirer toutes les hash (#) des URLs avant de vérifier? | défaut true
// stripGet(bool) : retirer tous les paramètres get (?var=val) des URLs avant de vérifier? | défaut false

export function urlsAreSamePage( args ) {
	let getParamsRegex = /\?.+$/;
	let trailingSlashRegexes = [
		{
			regex: /\/$/,
			replacement: '',
		},
		{
			regex: /\/\?/,
			replacement: '?',
		},
		{
			regex: /\/#/,
			replacement: '#',
		}
	];
	let nakedUrls = [];
	args = args || {};

	args.urls = args.urls || [];
	args.stripHash = args.stripHash || true;
	args.stripGet = args.stripGet || false;

	if( 'string' == typeof args.urls ) {
		args.urls = [ args.urls ];
	}

	// Une seule URL ? On compare avec celle de la page actuelle.
	if( Array.isArray( args.urls ) && 1 == args.urls.length ) {
		args.urls.push( window.location.href );
	}

	args.urls.forEach( function( thisUrl ) {
		let hashIndex = thisUrl.indexOf( '#' );
		let urlHash = -1 !== hashIndex ? thisUrl.substring( hashIndex ) : '';
		let nakedUrl = thisUrl;

		if( args.stripHash ) {
			nakedUrl = nakedUrl.replace( urlHash, '' );
		}

		if( args.stripGet ) {
			nakedUrl = nakedUrl.replace( getParamsRegex, '' );
		}

		trailingSlashRegexes.forEach( function( thisRegex ) {
			nakedUrl.replace( thisRegex.regex, thisRegex.replacement );
		} );

		nakedUrls.push( nakedUrl );
	} );

	return arrayAllEqual( nakedUrls );
}


// Combien de chiffres après la virgule le chiffre a-t-il ?
// https://stackoverflow.com/a/27082406/1995518

export function countDecimals( value ) {
	if( Math.floor(value) !== value ) {
		return value.toString().split(".")[1].length || 0;
	}
	return 0;
}


// Cet élément fait-il partie d'un élément no-scripts? Si oui on initialisera pas toutes sortes d'affaires.

export function scriptsOk( element ) {
	return element.closest( '.no-scripts' ) ? false : true;
}